module.exports = __webpack_public_path__ + "images/emoji/fountain.e0072d49e02125a6de49.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/fountain.png
// module id = UAsV
// module chunks = 13